window.libertasPrepareScrollLock = () => {
  const html = document.documentElement;
  const body = document.body;
  const bodyIsLocked = getComputedStyle(body).overflowY === 'hidden';
  const htmlIsLocked = getComputedStyle(html).overflowY === 'hidden';
  if (bodyIsLocked || htmlIsLocked) return;

  const scrollbarWidth = Math.max(0, window.innerWidth - html.clientWidth);
  html.style.setProperty('--lib-scrollbar-compensation', `${scrollbarWidth}px`);
};
